import { Country } from '@shared/models/country';

export function matchCountryByInput(
    value: string | Country | null | undefined,
    countries: Country[],
): Country | null {
    if (!value) {
        return null;
    }

    if (typeof value === 'object' && value.code) {
        return value;
    }

    if (typeof value !== 'string') {
        return null;
    }

    const normalized = value.trim().toLowerCase();

    if (!normalized) {
        return null;
    }

    const displayMatch = normalized.match(/^(.+?)\s*\(([a-z]{2})\)$/i);

    if (displayMatch) {
        const byCode = countries.find((country) => country.code.toLowerCase() === displayMatch[2].toLowerCase());

        if (byCode) {
            return byCode;
        }

        const byGermanName = countries.find((country) => country.de.toLowerCase() === displayMatch[1].trim().toLowerCase());

        if (byGermanName) {
            return byGermanName;
        }
    }

    if (normalized.length === 2) {
        return countries.find((country) => country.code.toLowerCase() === normalized) ?? null;
    }

    return countries.find((country) =>
        country.de.toLowerCase() === normalized
        || country.en.toLowerCase() === normalized
        || country.en_full?.toLowerCase() === normalized
        || country.code.toLowerCase() === normalized) ?? null;
}
